import React, { Component } from "react";
import './styles.css';
import background from 'url:../../assets/background.jpeg';
import { Link } from "react-scroll";


const Home = () => {
        return(
                
                <div className="row">
                    <div className="gfg col s12 m12 l12" >
                        <img className="background-pic" src={background} alt='background' />
                        <div className="headerText">
                        <h2 className="first-txt flow-text">DIRECT SIGNINGS SERVICES</h2>
                        <p className="subHeader flow-text">DIRECT US TO YOUR SIGNING NEEDS!</p>
                        <Link className="hero-cta" to="Contacts" smooth={true} offset={-100} duration={500}>Book a Signing</Link>
                        </div>
                    </div>
                </div>
                
        )
}

export default Home;